// src/components/CartBadge.jsx
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const bump = keyframes`
  0% { transform: scale(1); }
  10% { transform: scale(1.1); }
  30% { transform: scale(1); }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 1000;

  /* On mobile, move to bottom-right (respect iOS safe-area) */
  @media (max-width: 768px) {
    top: auto;
    bottom: 16px;
    right: 16px;
    padding-bottom: env(safe-area-inset-bottom);
  }
`;

const Pill = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(225, 214, 192, 0.95);
  color: #0d0d0d;
  border-radius: 999px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  cursor: pointer;

  @media (max-width: 768px) {
    /* Slightly bigger touch target on mobile */
    padding: 12px 16px;
  }
`;

const Count = styled.span`
  min-width: 22px;
  height: 22px;
  border-radius: 11px;
  background: #0d0d0d;
  color: #e1d6c0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  animation: ${props => (props.bump ? bump : 'none')} 400ms ease-out;
`;

const CartBadge = () => {
  const { items } = useCart();
  const location = useLocation();
  const count = items.reduce((sum, i) => sum + i.quantity, 0);
  const [bumpNow, setBumpNow] = React.useState(false);

  React.useEffect(() => {
    if (count > 0) {
      setBumpNow(true);
      const t = setTimeout(() => setBumpNow(false), 400);
      return () => clearTimeout(t);
    }
  }, [count]);

  // Only show on Menu page
  if (!location.pathname.startsWith('/menu')) return null;

  const to = '/order';

  return (
    <Wrapper>
      <Pill to={to} aria-label={`Go to order (${count} items)`}>
        <span role="img" aria-label="cart">🛒</span>
        <span>Order Pickup</span>
        <Count bump={bumpNow}>{count}</Count>
      </Pill>
    </Wrapper>
  );
};

export default CartBadge;
